<template>
  <div class="pa-20" ref="pageEnseigne" v-if="enseignes.length">
    <div class="level">
      <div class="level-left">
        <p class="has-text-grid-1 has-text-weight-bold is-size-18px">
          Enseignes associées au groupe {{enseignes[0].tiersParent.nomCommercial}}
        </p>
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-notification type="is-white" :closable="false" class="pa-10">
            <p class="is-size-14px has-text-default">
              Total groupe
              <strong class="pa-10">{{formatNombre(totalRecomGroupe)}}</strong> HT
            </p>
          </b-notification>
        </div>
        <div class="level-item">
          <!-- <b-button type="is-color-button" class="is-size-14px has-text-weight-bold"
            @click="modalIsActive = !modalIsActive">
            Détail
          </b-button> -->
        </div>
      </div>
    </div>
    <div class="columns is-multiline is-12">
      <div class="column is-3 mt-20" v-for="(enseigne, index) in enseignes" :key="index">
        <div class="card pointer" @click="accessPointDeVentes(enseigne.num)">
          <div class="card-content pa-10">
            <div class="content">
              <div class="media">
                <div class="media-left logo">
                  <img class="logo" :src="getImgPdv(enseigne.urlLogo)">
                </div>
                <div class="media-content">
                  <div class="content">
                    <p class="has-text-default is-size-10px">
                      <strong class="has-text-grid-1 is-size-7">
                        {{enseigne.nomCommercial}}
                      </strong>
                      <br>
                      {{enseigne.adrComplet}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer pa-10">
            <p class="is-size-14px has-text-grid-1">
              <strong>
                {{nbrePointsVente(enseigne.num)}} points de ventes
              </strong>
              <br>
              {{nbrePointsVente(enseigne.num)}} recommandations
            </p>
          </div>
        </div>
      </div>
    </div>
    <ModalCumulregies
    :modal-is-active="modalIsActive"
    :recoms="recoms"
    :type="type"
    :enseignes="enseignes.map(ens => ({
      libelle : ens.nomCommercial,
      id : ens.num,
    }))"
    @modalIsClose="modalIsActive = $event"/>
  </div>
</template>

<script>
import { formatNombre, getImgPdv } from '@/services/general/general';
import ModalCumulregies from '@/components/portailGroupe/modalCumulRegies';

export default {
  components: {
    ModalCumulregies,
  },
  props: {
    recoms: Array,
    enseignes: Array,
  },
  data() {
    return {
      modalIsActive: false,
      type: 'groupe',
    };
  },
  computed: {
    totalRecomGroupe() {
      if (!this.recoms.length) return 0;
      return this.recoms
        .map(recom => recom.data.montant)
        .reduce((a, b) => a + b);
    },
  },
  methods: {
    nbrePointsVente(id) {
      const pdv = this.recoms.filter(recom => recom.data.pointDeVentes[0].idEnseigne === id);
      return pdv.length;
    },
    accessPointDeVentes(idEnseigne) {
      this.$emit('go-to-list-enseigne', idEnseigne);
    },
    formatNombre(val) {
      return formatNombre(val);
    },
    getImgPdv(url) {
      return getImgPdv(url);
    },
  },
}
</script>

<style>

</style>